import React, { useState, useRef, useEffect, useCallback } from "react";
import TerritoryWiseGrid from "./Grids/TerritoryWiseGrid";
// import courseData from './mockData.json';
import ReportsFilter from "./ReportsFilter";
// import Year from '../Calendar/Year';

const TerritoryWise = () => {
    const [selectedYear, setSelectedYear] = useState();
    const [selectedCustomerCodeInfo, setSelectedCustomerCodeInfo] = useState("Customer Code");

    const handleCustomerCodeChange = (custCode) => {
        setSelectedCustomerCodeInfo(custCode);
    }

    const handleYearChange = (year) => {
        setSelectedYear(year);
    }

    const handleAddTraining = () => {
        setShowTrainingForm(true);
    }

    return (
        <div className="px-32 py-8">
            <div className="w-full sm:w-12/12">
                <ReportsFilter handleAddTraining={handleAddTraining} handleYearChange={handleYearChange} hideForecastButton={true} hideAddButton={false} handleCustomerCodeChange={handleCustomerCodeChange} />
            </div>
            <div className="flex flex-col mt-24 pt-16 mb-24 rounded-xl" style={{ backgroundColor: "#8B6392", textAlign:"center" }}>
                {/* <div className="pt-16" style={{ backgroundColor: "#8B6392" }}> */}
                <h4>2023 PLAN - TRAINING DAYS</h4>
                <TerritoryWiseGrid className="mt-8" planActualMonthWise={false} ytd={false} />
                {/* </div> */}
            </div>
            <div className="flex flex-col mt-24 mb-24 pt-16 rounded-xl" style={{ backgroundColor: "#729263", textAlign:"center" }}>
                <h4>ACTUAL YTD - AUGUST 2023</h4>
                <TerritoryWiseGrid className="mt-24" planActualMonthWise={false} ytd={false} />
            </div>
            <div className="flex flex-col mt-24 pt-16 rounded-xl" style={{ backgroundColor: "#613527", textAlign:"center" }}>
                <h4>2023 FORECAST-TRAINING DAYS</h4>
                <TerritoryWiseGrid className="mt-24" planActualMonthWise={false} ytd={false} />
            </div>
            <div className="flex flex-col mt-24 pt-16 rounded-xl" style={{ backgroundColor: "#705D2E", textAlign:"center" }}>
                <h4>2023 PLAN VS ACTUAL TRAINING DAYS</h4>
                <TerritoryWiseGrid className="mt-24" planActualMonthWise={true} ytd={false}/>
            </div>
            <div className="flex flex-col mt-24 pt-16 rounded-xl" style={{ backgroundColor: "#424487D", textAlign:"center" }}>
                <h4>YTD AUGUST 2023</h4>
                <TerritoryWiseGrid className="mt-24" planActualMonthWise={false} ytd={true}/>
            </div>
            {/* <div style={{ borderTop: "1px solid #FFFFFF", margin: "20px 20px" }}></div> */}
        </div>
    )
}

export default TerritoryWise;